import React from 'react';

const ShopManagement = () => {
  return (
    <div className="min-h-screen pt-24 bg-gray-50">
      <div className="container-custom">
        <h1 className="text-3xl font-bold text-gray-900">Shop Management</h1>
        <p className="text-gray-600 mt-2">Shop management coming soon.</p>
      </div>
    </div>
  );
};

export default ShopManagement;